
import { Component, Vue } from "vue-property-decorator";
import { StreamBarcodeReader } from "vue-barcode-reader";

@Component({
  components: {
    StreamBarcodeReader,
  },
})

export default class VueBarcodeReader extends Vue {

  private onDecode(decodedString: string): void {
    if (decodedString) {
      this.$emit("decode", decodedString);
    }
  }
}
